module.exports = __webpack_public_path__ + "img/astros.cb61f191.svg";